import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import {
  checkInputErrorMaxLength,
  checkInputErrorRequired,
  useInput,
  useTextarea,
  useSelect
} from '@chilecompra/react-kit'
import { Card, Input, Select, Textarea, Typography } from '@chilecompra/react-kit/components'

import { checkInputErrorMinValue } from '../../modules/utils/checkers'
import { LineJump, Grid, CloseIcon } from './QuoteStepTwo.styles'

/**
 * The product's component.
 */
const Products = props => {
  const {
    detail,
    onRemoveProduct,
    productId,
    productKey,
    productName,
    productsUpdate,
    quantity,
    setProductsUpdate,
    unit,
    unitsMeasureOption
  } = props
  const { authInfo } = useSelector(state => state.authorizationProvider)

  const productsSavedDetail = detail => {
    setProductsUpdate({
      ...productsUpdate,
      [productKey]: {
        ...productsUpdate[productKey],
        detail
      }
    })
  }

  const productsSavedQuantity = quantity => {
    setProductsUpdate({
      ...productsUpdate,
      [productKey]: {
        ...productsUpdate[productKey],
        quantity
      }
    })
  }

  const productsSavedUnit = unit => {
    setProductsUpdate({
      ...productsUpdate,
      [productKey]: {
        ...productsUpdate[productKey],
        unit
      }
    })
  }

  const {
    error: detailError,
    onChange: handleDetailChange,
    value: detailValue
  } = useTextarea({
    changeCallback: productsSavedDetail,
    errorCallbacks: [checkInputErrorMaxLength(500), checkInputErrorRequired()],
    initialValue: detail
  })

  const {
    error: quantityError,
    onChange: handleQuantityChange,
    value: quantityValue
  } = useInput({
    changeCallback: productsSavedQuantity,
    errorCallbacks: [
      checkInputErrorMaxLength(20),
      checkInputErrorRequired(),
      checkInputErrorMinValue(1, 'El valor no debe ser inferior a 1.')
    ],
    initialValue: quantity
  })

  const {
    error: unitsMeasureError,
    onChange: handleUnitsMeasureChange,
    value: unitsMeasureValue
  } = useSelect({
    changeCallback: productsSavedUnit,
    errorCallbacks: [checkInputErrorRequired()],
    initialValue: unit
  })

  const handleRemoveProduct = () => onRemoveProduct(productKey)

  return (
    <>
      <Card color="blank" enableBorder>
        <Grid container alignItems="flex-end" justifyContent="flex-start" margin="0 0 32px">
          <Typography
            color="black1"
            fontSize="14px"
            fontWeight="bold"
            lineHeight="18px"
            margin="0 4px 0 0"
            variant="body2"
          >
            {productName}
          </Typography>
          <Typography color="black3" fontSize="12px" lineHeight="16px" variant="subtitle">
            ID: {productId}
          </Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={2}>
            <Input
              disabled={authInfo.hasObserverRole}
              error={quantityError}
              label="Cantidad"
              maxLength={20}
              onChange={handleQuantityChange}
              value={quantityValue}
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Select
              disabled={authInfo.hasObserverRole}
              error={unitsMeasureError}
              label="Unidad"
              onChange={handleUnitsMeasureChange}
              options={unitsMeasureOption}
              value={unitsMeasureValue}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <Textarea
              disabled={authInfo.hasObserverRole}
              error={detailError}
              info=""
              label="Detalle"
              maxCount={500}
              maxLength={500}
              multiline
              onChange={handleDetailChange}
              showCounter
              value={detailValue}
            />
          </Grid>
        </Grid>
        <CloseIcon onClick={handleRemoveProduct} />
      </Card>
      <LineJump />
    </>
  )
}

Products.defaultProps = {
  detail: '',
  name: '',
  quantity: null,
  unit: null
}

Products.propTypes = {
  detail: PropTypes.string,
  productKey: PropTypes.string.isRequired,
  onRemoveProduct: PropTypes.func.isRequired,
  productId: PropTypes.number.isRequired,
  productName: PropTypes.string.isRequired,
  productsUpdate: PropTypes.object.isRequired,
  quantity: PropTypes.number,
  setProductsUpdate: PropTypes.func.isRequired,
  unit: PropTypes.number,
  unitsMeasureOption: PropTypes.isRequired
}

export default Products
